import React from 'react';
import { NetworkHighlightBlock } from '../CulinaryCollective/interface';
import NetworkHighlights from './NetworkHighlights';

interface CenturionIntroSectionProps {
  title: string;
  intro: string;
  networkHighlights: NetworkHighlightBlock[];
}

export const CenturionIntroSection: React.FC<CenturionIntroSectionProps> = ({
  title,
  intro,
  networkHighlights,
}) => {
  return (
    <div className="tw-flex tw-w-full tw-flex-col tw-pt-10">
      <div className="tw-font-serif tw-text-dls36 tw-font-normal tw-text-gray-900 md_tw-text-dls56">
        {title}
      </div>
      <div className="tw-pt-2 tw-font-sans tw-text-xl tw-text-gray-800 md_tw-text-2xl">
        {intro}
      </div>
      <NetworkHighlights highlights={networkHighlights} />
    </div>
  );
};
